export default "__VITE_ASSET__CkRZ67lL__"